export default __webpack_public_path__ + "static/media/0009.f540ac93.WAV";